import { render } from "./HeroiconsSolidTemplate.vue?vue&type=template&id=929976b4"
const script = {}

import exportComponent from "/Users/yllndritb/Projects/rent/rent-api/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidTemplate.vue"]])

export default __exports__